import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { LoginService } from './../services/login.service';
import { Component, OnInit } from '@angular/core';
import { TokenExpireService } from '../services/token-expire.service';

declare var $: any;

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit {
  constructor(
    private Logout: TokenExpireService,
    private Loader: CustomLoaderService
  ) {}

  ngOnInit() {
    this.Loader.show();
    setTimeout(() => {
      this.DeleteAcc();
      this.Loader.hide();
    }, 2000);
  }
  DeleteAcc() {
    debugger;
    $('#Delete').modal({ backdrop: 'static', keyboard: false });
  }
  OnDelete() {
    debugger;
    $('#SureDelete').modal({ backdrop: 'static', keyboard: false });
    this.closeNav();
  }

  closeNav() {
    document.getElementById('mySidenav').style.width = '0';
  }
}
